import React from 'react'
import { Field, formValueSelector } from 'redux-form'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { getColumns } from '../../../../utils/databases'
import Accordion from '../../../Shared/Accordion'
import Checkbox from '../../../Shared/Forms/Checkbox'
import WrappedInput from '../../../Shared/Forms/WrappedInput'
import { BaseInput } from '../../../Shared/Forms/DynamicInput'

import styles from './ViewSelector.module.css'

const Title = function Title({ field, title, enabled }) {
  return (
    <div className={classNames(styles.title, !enabled && styles.disabled)}>
      <h3>{title}</h3>
      <Field name={`${field}.enabled`} component={Checkbox} />
    </div>
  )
}

const getLabel = entity => entity.label || entity.column

export default function ViewSelector({ field, table, form }) {
  const selector = formValueSelector(form)

  const enabled = useSelector(state => selector(state, `${field}.enabled`))

  const labelOptions = table.columns.map(col => ({
    label: col.name,
    value: col.name,
  }))

  const infoOptions = getColumns(table, { primaryKey: true }).map(col => ({
    label: col.displayName || col.name,
    value: { column: col.name, label: col.displayName },
  }))

  return (
    <Accordion
      carret
      title={<Title enabled={enabled} field={field} title={table.name} />}
      className={styles.wrapper}
      group="viewSetup"
      id={table.name}
    >
      {() => (
        <div className={styles.children}>
          <div className={styles.childrenInner}>
            <Field
              name={`${field}.body.labelColumn`}
              component={WrappedInput}
              options={labelOptions}
              label="Label Field"
            />
            <Field
              name={`${field}.body.infoText`}
              component={BaseInput}
              options={infoOptions}
              getLabel={getLabel}
              label="Subtitle"
            />
          </div>
        </div>
      )}
    </Accordion>
  )
}
